<div class="w-100 full-height d-flex centerBlock loadingPage">
  <nz-spin nzSimple></nz-spin>
</div>
